import React from "react";
import StudentResourceTemplate from "./StudentResourceTemplate";

export const resourcePage = {
  id: "eee-resources",
  department: "Electrical & Electronics Engineering",
  short: "EEE",
  description: "student_resources for the Department of Electrical & Electronics Engineering.",
  resourceSet: "aiml",
  sections: [
    {
      title: "Syllabus",
      items: [
        {
          label: "Syllabus",
          href: "https://drive.google.com/drive/folders/121h2lZWgXv65w92shANzIiTNBZ6HcPvS?usp=drive_link",
        },
      ],
    },
    { title: "Timetable", items: [
        // {
        //   label: "1st Semester TimeTable",
        //   href: "#",
        // },
        // {
        //   label: "2nd Semester TimeTable",
        //   href: "#",
        // },
        // {
        //   label: "3rd Semester TimeTable",
        //   href: "#",
        // },
        {
          label: "4th Semester TimeTable",
          href: "/student_resources/EEE/TimeTable/EE_Time_Table_4th_Sem.pdf",
        },
        // {
        //   label: "5th Semester TimeTable",
        //   href: "#",
        // },
        {
          label: "6th Semester TimeTable",
          href: "/student_resources/EEE/TimeTable/6_Sem_Time_Table.pdf",
        },
    ] },
    { title: "Academic Calendar", items: [
      {
          label: "4th Sem COE",
          href: "/student_resources/EEE/COE/COE_EE_4th_Sem.pdf",
        },
         {
          label: "6th Sem COE",
          href: "/student_resources/EEE/COE/COE_6_Sem.pdf",
        },
    ] },
    {
      title: "IA Syllabus",
      items: [
        {
          label: "IA Syllabus",
          href: "https://drive.google.com/drive/folders/1pVbuMiGh9OIPjzUtV24RoS8rMPfFa8J6?usp=drive_link",
        },
      ],
    },
    {
        title: "Question Papers & Solutions",
        items: [
          {
            label: "Question Paper and Solution",
            href: "https://drive.google.com/drive/folders/1yV57PNELcZK29QauN4KdVTh7-egJkcsy?usp=drive_link",
          },
        ],
      },
    {
      title: "Add-On Subjects",
      items: [
        {
          label: "Add-On Course Syllabus",
          href: "https://drive.google.com/drive/folders/1tRZ2r_1ydxX1EKBVgsRrCY-eDM3BmjX7?usp=drive_link",
        },
      ],
    },
    // {
    //   title: "Published Papers & Patents",
    //   items: [
    //     {
    //       label: " INTEGRATED LEGAL CASE ANALYSIS AND DOCUMENT GENERATION SYSTEM USING RETRIEVAL-AUGMENTED AI MODELS ",
    //       // href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-396.pdf",
    //     },
    //     {
    //       label: " NETWORK TRAFFIC ANALYSIS FOR SECURITY ANOMALY ",
    //       // href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-799.pdf",
    //     },
    //     {
    //       label: " CROWD SENSE: A REAL-TIME SYSTEM FOR CROWD ANALYTICS",
    //       // href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-883.pdf",
    //     },
    //     {
    //       label: " AI-DRIVEN MOBILE FORENSICS",
    //       // href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-1145.pdf",
    //     },
    //     {
    //       label: " AI-BASED TEXT TO 3D MODEL GENERATOR",
    //       // href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-1793-793.pdf",
    //     },
    //   ],
    // },
    {
      title: "Mentor List",
      items: [
        {
          label: "2025-26",
          href: "/student_resources/EEE/MentorMentee/Counsellors-list-AY-2025-26.pdf",
        },
      ],
    },
  ],
};

const EEEResources = () => <StudentResourceTemplate resourcePage={resourcePage} />;

export default EEEResources;
